import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import Link from "@material-ui/core/Link";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Assignment from "@material-ui/icons/Assignment";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import LoginForm from "../form/loginForm";
import RegisterForm from "./Register";
import GoogleLoginForm from "./../form/googLogin";
import FacebookLoginForm from "./../form/facebookLogin";
import NewSnack from "../Snackbar/newSnack";

import Fetch from "../fetch/auth";
import Person from "@material-ui/icons/PersonOutline";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  responsiveButton: {
    display: "table",
    padding: "10px 18px 10px 0"
  },
  responsiveButtonRtl: {
    padding: "6px 0px 6px 17px"
  }
});
function TabContainer(props) {
  return <div style={{ padding: 8 * 3 }}>{props.children}</div>;
}

export default function LoginRegister(props) {
  const classes = useStyles();
  const {
    lang,
    setUser,
    myInvoice,
    multiLang,
    dir,
    isopen,
    close,
    header,
    setIsopen
  } = props;

  // const [open, setOpen] = useState(isopen);
  const [value, setValue] = React.useState(0);
  const [snack, setSnack] = useState({
    open: false,
    type: "error",
    message: "sample"
  });

  // function handleClose() {
  //   setOpen(false);
  // }

  function handleChange(event, newValue) {
    setValue(newValue);
  }
  function handleCloseing() {
    setSnack({
      open: false,
      type: "error",
      message: multiLang["A016"][lang]
    });
  }

  async function handelFacebook(e) {
    const data = {
      query: `
      mutation{
        loginFacebook{
          token
          user{
            name
            email
            picture
            mobile
            role
            hasPassword
          }
        }
      }
      `
    };
    const basic = "Bearer " + e;
    try {
      const response = await Fetch(JSON.stringify(data), basic);
      setSnack({
        open: false,
        type: "success",
        message: multiLang["A018"][lang]
      });
      // console.log(response);
      props.setUser(response.loginFacebook);
    } catch (err) {
      console.log("err", err);
      setSnack({
        open: false,
        type: "success",
        message: multiLang["A019"][lang]
      });
      // setSnackbar({ br: true, message: err[0].message });
      // setTimeout(() => {
      //   setSnackbar({ br: false, message: "" });
      // }, 6000);
    }
  }
  async function handelGoogle(e) {
    const body = {
      query: `
        mutation{
            loginGoogle{
              token
              user{
                name
                email
                picture
                mobile
                role
                hasPassword
              }
            }
          }
          `
    };
    const auth = "Bearer " + e;
    try {
      const response = await Fetch({ auth, body: JSON.stringify(body) });
      setSnack({
        open: true,
        type: "success",
        message: multiLang["A018"][lang]
      });
      setUser(response.loginGoogle);
    } catch (err) {
      console.log(err);
      setSnack({
        open: true,
        type: "error",
        message: multiLang["A019"][lang]
      });
    }
  }

  return (
    <>
      {header && (
        <>
          <Hidden mdUp implementation="js">
            <Button
              className={
                dir === "ltr"
                  ? classes.responsiveButton
                  : classes.responsiveButtonRtl
              }
              onClick={() => setIsopen(true)}
            >
              <Person />
            </Button>
          </Hidden>
          <Hidden smDown implementation="js">
            <NewSnack snack={snack} handleClose={handleCloseing} />
            <Link
              component="button"
              color="inherit"
              onClick={() => setIsopen(true)}
              style={{
                display: "inline-flex",
                alignSelf: "center",
                paddingBottom: "3px",
                fontSize: "16px"
              }}
            >
              {multiLang["013"][lang]}
            </Link>
          </Hidden>
        </>
      )}
      <Dialog
        open={isopen}
        // keepMounted
        onClose={() => close()}
        className={dir === "rtl" ? "rtl" : "ltr"}
      >
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label={multiLang["021"][lang]} icon={<AssignmentInd />} />
            <Tab label={multiLang["022"][lang]} icon={<Assignment />} />
          </Tabs>
        </AppBar>
        {value === 0 && (
          <TabContainer>
            <LoginForm
              setUser={setUser}
              myInvoice={myInvoice}
              lang={lang}
              multiLang={multiLang}
              dir={dir}
            />
          </TabContainer>
        )}
        {value === 1 && (
          <TabContainer>
            <RegisterForm
              setUser={setUser}
              multiLang={multiLang}
              lang={lang}
              dir={dir}
            />
          </TabContainer>
        )}

        <div>
          <ul style={{ listStyle: "none" }}>
            {/* <li>Forgot Your Password?</li> */}
            <li style={{ marginBottom: "10px" }}>
              <GoogleLoginForm
                login={handelGoogle}
                multiLang={multiLang}
                lang={lang}
                dir={dir}
              />
            </li>
            <li>
              <FacebookLoginForm
                login={handelFacebook}
                multiLang={multiLang}
                lang={lang}
                dir={dir}
              />
            </li>
          </ul>
        </div>
      </Dialog>
    </>
  );
}
